import React from 'react';
import Hot_tour_team_m from './hot_tour_team_m';
import Hot_tour_team_w from './hot_tour_team_w';

export default function Hot_tour_team(){

    return (
        <div >
        <div className='hidden md:block'>  <Hot_tour_team_w /></div>
        <div className='md:hidden md-my:5'> <Hot_tour_team_m /> </div>
        </div>
    )
}